<script lang="ts">
  import { chat } from '../store';

  const me = $derived($chat.me);
  let value = $state('');

  const chosen = $derived(value.trim());

  function save() {
    if (chosen) chat.setMeName(chosen);
  }
</script>

{#if !me.named}
  <div class="modal-backdrop name-prompt">
    <div class="modal small" role="dialog" aria-modal="true" aria-labelledby="name-prompt-title">
      <header class="modal-head">
        <strong id="name-prompt-title">Pick your name</strong>
      </header>
      <div class="modal-body">
        <p class="hint">Other people see this name on every message and call you join.</p>
        <input
          autofocus
          bind:value
          maxlength={48}
          aria-label="Your display name"
          onkeydown={(event) => {
            if (event.key === 'Enter' && chosen) save();
          }}
        />
        {#if !chosen}
          <p class="hint">We suggested a name from this device. Type your own, or continue as {me.name}.</p>
        {/if}
      </div>
      <footer class="modal-foot">
        <button class="btn" onclick={save} disabled={!chosen}>Save name</button>
        <button class="btn ghost" onclick={() => chat.setMeName(me.name)}>Continue as {me.name}</button>
      </footer>
    </div>
  </div>
{/if}
